var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.743 12.575 9.91 8.74a5.426 5.426 0 0 0 1.05-3.232A5.532 5.532 0 0 0 5.46 0 5.436 5.436 0 0 0 0 5.468a5.532 5.532 0 0 0 5.5 5.509 5.409 5.409 0 0 0 3.242-1.062l.004-.003 3.83 3.832a.826.826 0 1 0 1.167-1.17ZM5.496 9.879a4.426 4.426 0 0 1-4.4-4.407 4.35 4.35 0 0 1 4.368-4.374 4.426 4.426 0 0 1 4.4 4.406 4.35 4.35 0 0 1-4.368 4.375Z",
    fill: "#000"
  })));
};

export default SvgSearchIcon;